import { ButtonThemePalette } from '../Button.types';

export const select = ({ button }: ButtonThemePalette): string => `
  background-color: ${button.background.select.base};
  border: 1px solid ${button.border.select.base};
  color: ${button.text.select.base};

  &:hover {
    border: 2px solid ${button.border.select.hover};
  }

  &:after {
    background-color: ${button.background.select.after};
    color: ${button.text.select.base};
  }
`;
